import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Injector, Optional } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ISizeName } from '@df/core/service/client';
import { StylesService } from '@df/core/service/styles';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NModalLayoutRight } from '../../../ui/modal/modal-layout-right.component';
import { WishlistShareFormComponent } from './wishlist-share-form.component';
export interface IOffCanvasSearchTrayModalBlockData extends Catalog.IBlockData<IOffCanvasSearchTrayModalBlockDataContent> {}
export interface IOffCanvasSearchTrayModalBlockDataContent {
    description?: string;
}
const getHeight = (size: ISizeName): string =>
    ({ S: StylesService.vh(100), M: StylesService.vh(100), L: StylesService.vw(100), X: '100.0rem' })[size];
@DfCmsModal({
    id: 'wishlist_share_modal',
    name: 'Wishlist Share Modal',
    position: 'right',
    config: size => ({
        width: NModalLayoutRight.getWidth(size),
        height: getHeight(size),
        maxWidth: '100vw',
        modalClass: 'bg-col-w p-a-10 p-a-4-s',
        position: { top: '0', right: '0' },
        closeOnNavigation: true
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@ICmsComponent<WishlistShareModalComponent>({
    id: 'wishlist_share',
    block: {
        url: 'wishlist_share'
    },
    onDemandOnly: true,
    name: 'Wishlist Share',
    description: 'Wishlist share',
    fields: [
        <NICmsContentField.IField>{
            key: 'description',
            type: NICmsContentField.EFieldType.text,
            title: 'Description'
        }
    ]
})
@Component({
    selector: 'wishlist-share-modal',
    templateUrl: 'wishlist-share-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [WishlistShareFormComponent, TranslationModule, CommonModule, ICmsClientModule]
})
export class WishlistShareModalComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: IOffCanvasSearchTrayModalBlockData;

    constructor(
        override readonly injector: Injector,
        @Optional()
        private modalRef: ModalRef<WishlistShareModalComponent>
    ) {
        super();
    }
    close() {
        this.modalRef?.close();
    }
}
